// extracted by mini-css-extract-plugin
module.exports = {"md":"bonus-icon_md_rNwPw","ios":"bonus-icon_ios_1XBfy","icon":"bonus-icon_icon_1qto6"};